var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.9999 36.6663c9.2048 0 16.6667-7.4619 16.6667-16.6666 0-9.2048-7.4619-16.66669-16.6667-16.66669-9.2047 0-16.66665 7.46189-16.66665 16.66669 0 9.2047 7.46195 16.6666 16.66665 16.6666z",
    fillOpacity: 0.35,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.3332 14.492c0-1.0283-1.24-1.545-1.97-.8216l-5.19 5.1416c-.66.655-.66 1.7217 0 2.3767l5.19 5.1417c.73.7233 1.97.205 1.97-.8217z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.6667 21.6663h11.6667c.92 0 1.6667-.7466 1.6667-1.6666s-.7467-1.6667-1.6667-1.6667c-.58 0-11.6667 0-11.6667 0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.e04c3ff77d8ef9943530c2f054b18236.svg";
export { ForwardRef as ReactComponent };